// @ts-nocheck
import { dapiFetchCache, dapiFetch, IDapiRequest } from '@origin-digital/daxi';

import {
  IErrors,
  IIAggregationCount,
  IIAnalysisSuccessResponse,
  IIBaseResponse,
  IIBatterUsageResponse,
  IIBatteryUsageInput,
  IIGenericResponse,
  IILeadInput,
  IILeadRecord,
  IIPatchLeadInput,
  IIProductReviewMappingDeleteInput,
  IIProductReviewMappingInput,
  IIProductReviewMappingRecord,
  IIRatingsAndReviewsResponse,
  IIRecommendationResponse,
  IIRoofImageResponse,
  IIServiceProviderDetailWithPricing,
  IIServiceabilityAddressRequest,
  IIServiceabilityBuildingRequest,
  IIServiceabilityResponse,
  IISession,
  IISolarBatteryOutlookResponse,
  IISubmitLeadResponse,
  IIUsageSessionResponse,
  IIUserUsageInput,
} from '../models';

/*
 * This code has been generated from an OpenAPI spec.
 */

export interface IV1AnalysisPostRequest extends IISession {
}

/**
 * @summary Roof analysis
 */
export const v1AnalysisPost = async (baseUrl: string, data: IV1AnalysisPostRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIAnalysisSuccessResponse> => {
    try {
        const method = 'POST';
        const url = baseUrl + v1AnalysisPostUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<IIAnalysisSuccessResponse>(url + queryString, fetchOptions);
          return response.data as IIAnalysisSuccessResponse;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<IIAnalysisSuccessResponse>(url + queryString, fetchOptions);
        return response.data as IIAnalysisSuccessResponse;
    } catch (error) {
        error.newRelic = `'POST: ${ v1AnalysisPostUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1AnalysisPost endpoint url that substitutes in given url params.
  */
const v1AnalysisPostUrl = () => {
    return '/v1/analysis';
};


export interface IV1BatteryUsagePostRequest extends IIBatteryUsageInput {
}

/**
 * @summary Calculating the battery usage costs
 */
export const v1BatteryUsagePost = async (baseUrl: string, data: IV1BatteryUsagePostRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIBatterUsageResponse> => {
    try {
        const method = 'POST';
        const url = baseUrl + v1BatteryUsagePostUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<IIBatterUsageResponse>(url + queryString, fetchOptions);
          return response.data as IIBatterUsageResponse;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<IIBatterUsageResponse>(url + queryString, fetchOptions);
        return response.data as IIBatterUsageResponse;
    } catch (error) {
        error.newRelic = `'POST: ${ v1BatteryUsagePostUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1BatteryUsagePost endpoint url that substitutes in given url params.
  */
const v1BatteryUsagePostUrl = () => {
    return '/v1/battery/usage';
};


export interface IV1ImageSessionIdGetRequest {
  sessionId: string;
}

/**
 * @summary Get the roof image
 */
export const v1ImageSessionIdGet = async (baseUrl: string, data: IV1ImageSessionIdGetRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIRoofImageResponse> => {
    try {
        const method = 'GET';
        const url = baseUrl + v1ImageSessionIdGetUrl(data);
        const queryString = '';

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<IIRoofImageResponse>(url + queryString, fetchOptions);
          return response.data as IIRoofImageResponse;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<IIRoofImageResponse>(url + queryString, fetchOptions);
        return response.data as IIRoofImageResponse;
    } catch (error) {
        error.newRelic = `'GET: ${ v1ImageSessionIdGetUrl(data) }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1ImageSessionIdGet endpoint url that substitutes in given url params.
  */
const v1ImageSessionIdGetUrl = (data: IV1ImageSessionIdGetRequest) => {
    return '/v1/image/{sessionId}'.replace('{' + 'sessionId' + '}', encodeURIComponent(data.sessionId));
};


export interface IV1LeadCountGetRequest {
  filter?: string;
}

/**
 * @summary Returns lead count
 */
export const v1LeadCountGet = async (baseUrl: string, data: IV1LeadCountGetRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<Array<IIAggregationCount>> => {
    try {
        const method = 'GET';
        const url = baseUrl + v1LeadCountGetUrl();
        const params: any = data;
        const queryString = '?' + ['filter',]
        .filter(k => params[k] !== undefined)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<Array<IIAggregationCount>>(url + queryString, fetchOptions);
          return response.data as Array<IIAggregationCount>;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<Array<IIAggregationCount>>(url + queryString, fetchOptions);
        return response.data as Array<IIAggregationCount>;
    } catch (error) {
        error.newRelic = `'GET: ${ v1LeadCountGetUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1LeadCountGet endpoint url that substitutes in given url params.
  */
const v1LeadCountGetUrl = () => {
    return '/v1/lead-count';
};


export interface IV1LeadLeadIdPatchRequest extends IIPatchLeadInput {
  leadId: string;
}

/**
 * @summary Partially updates lead
 */
export const v1LeadLeadIdPatch = async (baseUrl: string, data: IV1LeadLeadIdPatchRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IILeadRecord> => {
    try {
        const method = 'PATCH';
        const url = baseUrl + v1LeadLeadIdPatchUrl(data);
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<IILeadRecord>(url + queryString, fetchOptions);
          return response.data as IILeadRecord;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<IILeadRecord>(url + queryString, fetchOptions);
        return response.data as IILeadRecord;
    } catch (error) {
        error.newRelic = `'PATCH: ${ v1LeadLeadIdPatchUrl(data) }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1LeadLeadIdPatch endpoint url that substitutes in given url params.
  */
const v1LeadLeadIdPatchUrl = (data: IV1LeadLeadIdPatchRequest) => {
    return '/v1/lead/{leadId}'.replace('{' + 'leadId' + '}', encodeURIComponent(data.leadId));
};


export interface IV1LeadPostRequest extends IILeadInput {
}

/**
 * @summary Provides the lead response to the caller
 */
export const v1LeadPost = async (baseUrl: string, data: IV1LeadPostRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IISubmitLeadResponse> => {
    try {
        const method = 'POST';
        const url = baseUrl + v1LeadPostUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<IISubmitLeadResponse>(url + queryString, fetchOptions);
          return response.data as IISubmitLeadResponse;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<IISubmitLeadResponse>(url + queryString, fetchOptions);
        return response.data as IISubmitLeadResponse;
    } catch (error) {
        error.newRelic = `'POST: ${ v1LeadPostUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1LeadPost endpoint url that substitutes in given url params.
  */
const v1LeadPostUrl = () => {
    return '/v1/lead';
};


export interface IV1ProductReviewMappingDeleteRequest extends IIProductReviewMappingDeleteInput {
}

/**
 * @summary 
 */
export const v1ProductReviewMappingDelete = async (baseUrl: string, data: IV1ProductReviewMappingDeleteRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<void> => {
    try {
        const method = 'DELETE';
        const url = baseUrl + v1ProductReviewMappingDeleteUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<void>(url + queryString, fetchOptions);
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<void>(url + queryString, fetchOptions);
    } catch (error) {
        error.newRelic = `'DELETE: ${ v1ProductReviewMappingDeleteUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1ProductReviewMappingDelete endpoint url that substitutes in given url params.
  */
const v1ProductReviewMappingDeleteUrl = () => {
    return '/v1/product-review/mapping';
};


export interface IV1ProductReviewMappingPutRequest extends IIProductReviewMappingInput {
}

/**
 * @summary 
 */
export const v1ProductReviewMappingPut = async (baseUrl: string, data: IV1ProductReviewMappingPutRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<Array<IIProductReviewMappingRecord>> => {
    try {
        const method = 'PUT';
        const url = baseUrl + v1ProductReviewMappingPutUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<Array<IIProductReviewMappingRecord>>(url + queryString, fetchOptions);
          return response.data as Array<IIProductReviewMappingRecord>;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<Array<IIProductReviewMappingRecord>>(url + queryString, fetchOptions);
        return response.data as Array<IIProductReviewMappingRecord>;
    } catch (error) {
        error.newRelic = `'PUT: ${ v1ProductReviewMappingPutUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1ProductReviewMappingPut endpoint url that substitutes in given url params.
  */
const v1ProductReviewMappingPutUrl = () => {
    return '/v1/product-review/mapping';
};


export interface IV1QuoteSessionIdGetRequest {
  sessionId: string;
  phase?: string;
}

/**
 * @summary Provides the quote response to the caller
 */
export const v1QuoteSessionIdGet = async (baseUrl: string, data: IV1QuoteSessionIdGetRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIRecommendationResponse> => {
    try {
        const method = 'GET';
        const url = baseUrl + v1QuoteSessionIdGetUrl(data);
        const params: any = data;
        const queryString = '?' + ['phase',]
        .filter(k => params[k] !== undefined)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<IIRecommendationResponse>(url + queryString, fetchOptions);
          return response.data as IIRecommendationResponse;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<IIRecommendationResponse>(url + queryString, fetchOptions);
        return response.data as IIRecommendationResponse;
    } catch (error) {
        error.newRelic = `'GET: ${ v1QuoteSessionIdGetUrl(data) }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1QuoteSessionIdGet endpoint url that substitutes in given url params.
  */
const v1QuoteSessionIdGetUrl = (data: IV1QuoteSessionIdGetRequest) => {
    return '/v1/quote/{sessionId}'.replace('{' + 'sessionId' + '}', encodeURIComponent(data.sessionId));
};


export interface IV1SearchGetRequest {
  leadId?: string;
  uhubReferenceCode?: string;
}

/**
 * @summary Searches lead by id or uhubReferenceCode
 */
export const v1SearchGet = async (baseUrl: string, data: IV1SearchGetRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IILeadRecord> => {
    try {
        const method = 'GET';
        const url = baseUrl + v1SearchGetUrl();
        const params: any = data;
        const queryString = '?' + ['leadId','uhubReferenceCode',]
        .filter(k => params[k] !== undefined)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<IILeadRecord>(url + queryString, fetchOptions);
          return response.data as IILeadRecord;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<IILeadRecord>(url + queryString, fetchOptions);
        return response.data as IILeadRecord;
    } catch (error) {
        error.newRelic = `'GET: ${ v1SearchGetUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1SearchGet endpoint url that substitutes in given url params.
  */
const v1SearchGetUrl = () => {
    return '/v1/search';
};


export interface IV1ServiceProviderDetailsRatingReviewsGetRequest {
  serviceProviderIds: string;
}

/**
 * @summary Get Ratings and Reviews of service providers
 */
export const v1ServiceProviderDetailsRatingReviewsGet = async (baseUrl: string, data: IV1ServiceProviderDetailsRatingReviewsGetRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIRatingsAndReviewsResponse> => {
    try {
        const method = 'GET';
        const url = baseUrl + v1ServiceProviderDetailsRatingReviewsGetUrl();
        const params: any = data;
        const queryString = '?' + ['serviceProviderIds',]
        .filter(k => params[k] !== undefined)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<IIRatingsAndReviewsResponse>(url + queryString, fetchOptions);
          return response.data as IIRatingsAndReviewsResponse;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<IIRatingsAndReviewsResponse>(url + queryString, fetchOptions);
        return response.data as IIRatingsAndReviewsResponse;
    } catch (error) {
        error.newRelic = `'GET: ${ v1ServiceProviderDetailsRatingReviewsGetUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1ServiceProviderDetailsRatingReviewsGet endpoint url that substitutes in given url params.
  */
const v1ServiceProviderDetailsRatingReviewsGetUrl = () => {
    return '/v1/service-provider-details-rating-reviews';
};


export interface IV1ServiceProviderDetailsRatingReviewsPutRequest {
}

/**
 * @summary Refresh Product Review data
 */
export const v1ServiceProviderDetailsRatingReviewsPut = async (baseUrl: string,  authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<void> => {
    try {
        const method = 'PUT';
        const url = baseUrl + v1ServiceProviderDetailsRatingReviewsPutUrl();
        const queryString = '';

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<void>(url + queryString, fetchOptions);
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<void>(url + queryString, fetchOptions);
    } catch (error) {
        error.newRelic = `'PUT: ${ v1ServiceProviderDetailsRatingReviewsPutUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1ServiceProviderDetailsRatingReviewsPut endpoint url that substitutes in given url params.
  */
const v1ServiceProviderDetailsRatingReviewsPutUrl = () => {
    return '/v1/service-provider-details-rating-reviews';
};


export interface IV1ServiceProviderDetailsSessionIdGetRequest {
  sessionId: string;
  systemSize: string;
  phase?: string;
  systemType?: string;
  degradedExperience?: boolean;
}

/**
 * @summary Get detail of our partners/providers by ids
 */
export const v1ServiceProviderDetailsSessionIdGet = async (baseUrl: string, data: IV1ServiceProviderDetailsSessionIdGetRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<Array<IIServiceProviderDetailWithPricing>> => {
    try {
        const method = 'GET';
        const url = baseUrl + v1ServiceProviderDetailsSessionIdGetUrl(data);
        const params: any = data;
        const queryString = '?' + ['systemSize','phase','systemType','degradedExperience',]
        .filter(k => params[k] !== undefined)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<Array<IIServiceProviderDetailWithPricing>>(url + queryString, fetchOptions);
          return response.data as Array<IIServiceProviderDetailWithPricing>;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<Array<IIServiceProviderDetailWithPricing>>(url + queryString, fetchOptions);
        return response.data as Array<IIServiceProviderDetailWithPricing>;
    } catch (error) {
        error.newRelic = `'GET: ${ v1ServiceProviderDetailsSessionIdGetUrl(data) }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1ServiceProviderDetailsSessionIdGet endpoint url that substitutes in given url params.
  */
const v1ServiceProviderDetailsSessionIdGetUrl = (data: IV1ServiceProviderDetailsSessionIdGetRequest) => {
    return '/v1/service-provider-details/{sessionId}'.replace('{' + 'sessionId' + '}', encodeURIComponent(data.sessionId));
};


export interface IV1ServiceabilityAddressPostRequest extends IIServiceabilityAddressRequest {
}

/**
 * @summary Is the area serviced?
 */
export const v1ServiceabilityAddressPost = async (baseUrl: string, data: IV1ServiceabilityAddressPostRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIServiceabilityResponse> => {
    try {
        const method = 'POST';
        const url = baseUrl + v1ServiceabilityAddressPostUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<IIServiceabilityResponse>(url + queryString, fetchOptions);
          return response.data as IIServiceabilityResponse;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<IIServiceabilityResponse>(url + queryString, fetchOptions);
        return response.data as IIServiceabilityResponse;
    } catch (error) {
        error.newRelic = `'POST: ${ v1ServiceabilityAddressPostUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1ServiceabilityAddressPost endpoint url that substitutes in given url params.
  */
const v1ServiceabilityAddressPostUrl = () => {
    return '/v1/serviceability/address';
};


export interface IV1ServiceabilityBuildingPostRequest extends IIServiceabilityBuildingRequest {
}

/**
 * @summary Is the area serviced?
 */
export const v1ServiceabilityBuildingPost = async (baseUrl: string, data: IV1ServiceabilityBuildingPostRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIServiceabilityResponse> => {
    try {
        const method = 'POST';
        const url = baseUrl + v1ServiceabilityBuildingPostUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<IIServiceabilityResponse>(url + queryString, fetchOptions);
          return response.data as IIServiceabilityResponse;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<IIServiceabilityResponse>(url + queryString, fetchOptions);
        return response.data as IIServiceabilityResponse;
    } catch (error) {
        error.newRelic = `'POST: ${ v1ServiceabilityBuildingPostUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1ServiceabilityBuildingPost endpoint url that substitutes in given url params.
  */
const v1ServiceabilityBuildingPostUrl = () => {
    return '/v1/serviceability/building';
};


export interface IV1SessionIdPostRequest {
}

/**
 * @summary Generate a new session id
 */
export const v1SessionIdPost = async (baseUrl: string,  authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIBaseResponse> => {
    try {
        const method = 'POST';
        const url = baseUrl + v1SessionIdPostUrl();
        const queryString = '';

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<IIBaseResponse>(url + queryString, fetchOptions);
          return response.data as IIBaseResponse;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<IIBaseResponse>(url + queryString, fetchOptions);
        return response.data as IIBaseResponse;
    } catch (error) {
        error.newRelic = `'POST: ${ v1SessionIdPostUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1SessionIdPost endpoint url that substitutes in given url params.
  */
const v1SessionIdPostUrl = () => {
    return '/v1/session-id';
};


export interface IV1SolarBatteryOutlookSessionIdGetRequest {
  sessionId: string;
}

/**
 * @summary Provides the quote response to the caller
 */
export const v1SolarBatteryOutlookSessionIdGet = async (baseUrl: string, data: IV1SolarBatteryOutlookSessionIdGetRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<Array<IISolarBatteryOutlookResponse>> => {
    try {
        const method = 'GET';
        const url = baseUrl + v1SolarBatteryOutlookSessionIdGetUrl(data);
        const queryString = '';

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<Array<IISolarBatteryOutlookResponse>>(url + queryString, fetchOptions);
          return response.data as Array<IISolarBatteryOutlookResponse>;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<Array<IISolarBatteryOutlookResponse>>(url + queryString, fetchOptions);
        return response.data as Array<IISolarBatteryOutlookResponse>;
    } catch (error) {
        error.newRelic = `'GET: ${ v1SolarBatteryOutlookSessionIdGetUrl(data) }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1SolarBatteryOutlookSessionIdGet endpoint url that substitutes in given url params.
  */
const v1SolarBatteryOutlookSessionIdGetUrl = (data: IV1SolarBatteryOutlookSessionIdGetRequest) => {
    return '/v1/solar-battery/outlook/{sessionId}'.replace('{' + 'sessionId' + '}', encodeURIComponent(data.sessionId));
};


export interface IV1TestDataLeadPutRequest extends IILeadRecord {
}

/**
 * @summary Updates test data for leads
 */
export const v1TestDataLeadPut = async (baseUrl: string, data: IV1TestDataLeadPutRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIGenericResponse> => {
    try {
        const method = 'PUT';
        const url = baseUrl + v1TestDataLeadPutUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<IIGenericResponse>(url + queryString, fetchOptions);
          return response.data as IIGenericResponse;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<IIGenericResponse>(url + queryString, fetchOptions);
        return response.data as IIGenericResponse;
    } catch (error) {
        error.newRelic = `'PUT: ${ v1TestDataLeadPutUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1TestDataLeadPut endpoint url that substitutes in given url params.
  */
const v1TestDataLeadPutUrl = () => {
    return '/v1/test-data/lead';
};


export interface IV1UsagePostRequest extends IIUserUsageInput {
}

/**
 * @summary Calculating the usage costs
 */
export const v1UsagePost = async (baseUrl: string, data: IV1UsagePostRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IIUsageSessionResponse> => {
    try {
        const method = 'POST';
        const url = baseUrl + v1UsagePostUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<IIUsageSessionResponse>(url + queryString, fetchOptions);
          return response.data as IIUsageSessionResponse;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<IIUsageSessionResponse>(url + queryString, fetchOptions);
        return response.data as IIUsageSessionResponse;
    } catch (error) {
        error.newRelic = `'POST: ${ v1UsagePostUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1UsagePost endpoint url that substitutes in given url params.
  */
const v1UsagePostUrl = () => {
    return '/v1/usage';
};


export interface IV1ViewCountProviderIdPutRequest {
  providerId: string;
}

/**
 * @summary 
 */
export const v1ViewCountProviderIdPut = async (baseUrl: string, data: IV1ViewCountProviderIdPutRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<void> => {
    try {
        const method = 'PUT';
        const url = baseUrl + v1ViewCountProviderIdPutUrl(data);
        const queryString = '';

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<void>(url + queryString, fetchOptions);
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<void>(url + queryString, fetchOptions);
    } catch (error) {
        error.newRelic = `'PUT: ${ v1ViewCountProviderIdPutUrl(data) }'`;
        throw error;
    }
};

/**
  * Generate a getter for the v1ViewCountProviderIdPut endpoint url that substitutes in given url params.
  */
const v1ViewCountProviderIdPutUrl = (data: IV1ViewCountProviderIdPutRequest) => {
    return '/v1/view-count/{providerId}'.replace('{' + 'providerId' + '}', encodeURIComponent(data.providerId));
};

